import { render, staticRenderFns } from "./PopupMgm.vue?vue&type=template&id=6c8daa95&"
import script from "./PopupMgm.vue?vue&type=script&lang=js&"
export * from "./PopupMgm.vue?vue&type=script&lang=js&"
import style0 from "./PopupMgm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ModalWindow: require('/builds/2oYM8JSf/1/mcp/sk-soutez-2022/frontend/components/ModalWindow.vue').default})
